App.controller('StoreCtrl', function($scope,$rootScope){
	
});
